import { render, staticRenderFns } from "./SlotsItem.vue?vue&type=template&id=108a08e7&lang=pug"
import script from "./SlotsItem.vue?vue&type=script&lang=js"
export * from "./SlotsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports